import { CompozzIcon } from "./CompozzIcon";

interface ObjectActionDto {
	_key: string;
	order: number;
	label: string;
	description: string;
	icon: CompozzIcon | null;
	color: string;
	views: string[];
	successMsg: string;
	errorMsg: string;
	confirmationMsg: string;
	refresh: boolean;
	// The action button is shown even when no row is selected (the action is
	// then executed without record)
	alwaysVisible?: boolean;
}

// Returns the actions whose button is shown: all of them when rows are
// selected, only the ones always visible otherwise
export const visibleObjectActions = (actions: ObjectActionDto[], hasSelection: boolean): ObjectActionDto[] =>
	hasSelection ? actions : actions.filter((action) => action.alwaysVisible);

export default ObjectActionDto;
